"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGENT_TYPES = void 0;
exports.AGENT_TYPES = Object.freeze({
    LEASING_AGENT: 'leasing_agent',
    LEASING_COORDINATOR: 'leasing_coordinator',
    LEASING_MOD: 'leasing_mod'
});
